import { gql } from '@apollo/client/core'
import { client } from '../apollo/client'
import { ImageSizeQuery, ImageSizeQueryVariables } from './__generated__/fetchImageDimensions'

export const IMAGE_DIMENSIONS_QUERY = gql`
  query ImageSizeQuery($id: [QueryArgument]) {
    asset(id: $id) {
      width
      height
    }
  }
`

export const fetchImageDimensions = async (id: string): Promise<ImageSizeQuery['asset']> => {
  const { data } = await client.query<ImageSizeQuery, ImageSizeQueryVariables>({
    query: IMAGE_DIMENSIONS_QUERY,
    variables: { id },
    context: {
      batch: true,
    },
  })

  return data.asset
}